module.exports = __webpack_public_path__ + "static/media/banner_12.4a279cb1.jpg";